import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { heroTestimonial } from '../data/testimonials';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function TestimonialHighlight() {
  return <section className="bg-mp-dark py-14 md:py-20" data-id="element-272" data-mp="18tz4ph4bokaw">
      <Container data-id="element-273" data-mp="18rcnsqvjksg0">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto max-w-[700px] rounded-2xl border border-mp-lime/30 bg-mp-card p-8 text-center md:p-10" data-id="element-274" data-mp="1dt216d68li79">
          <div className="flex items-center justify-center gap-0.5" aria-hidden="true" data-id="element-275" data-mp="1rix52wq85ee4">
            {Array.from({
            length: 5
          }).map((_, idx) => <StarIcon key={idx} className="h-4 w-4 fill-mp-lime text-mp-lime" data-id="element-276" data-mp="21ie816e3de6e" data-mpi={idx} />)}
          </div>
          <p className="mt-5 text-lg leading-relaxed text-mp-white md:text-xl" data-id="element-277" data-mp="2yus682xui0mf">"{heroTestimonial.quote}"</p>
          <p className="mt-5 text-sm text-mp-gray" data-id="element-278" data-mp="2tvfh1bji4hgo">
            — {heroTestimonial.author}, {heroTestimonial.role} ({heroTestimonial.location})
          </p>
        </motion.div>
      </Container>
    </section>;
}